import { Toaster } from 'sonner';
import style from './style.module.css';

/**
 * Toaster applicatif (Sonner), monté une seule fois à la racine. Les toasts s'émettent via
 * `toast.info()` / `.success()` / `.warning()` / `.error()` depuis n'importe où — les types
 * sont mappés sur les tokens couleur du thème (variables.css), jamais sur `richColors`.
 * Bas-centre, hors safe areas (notch/barre home) — swipe-to-dismiss et empilement fournis
 * par la lib.
 */
const AppToaster = () => (
    <Toaster
        position="bottom-center"
        offset="24px"
        mobileOffset="calc(16px + env(safe-area-inset-bottom))"
        toastOptions={{
            className: style.toast,
            duration: 8000,
            classNames: {
                info: style.info,
                success: style.success,
                warning: style.warning,
                error: style.error
            }
        }}
    />
);

export default AppToaster;
